import currency from "currency.js";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import {
    setAlert,
    setCreditCardForm,
    setSelectedPost,
    updateCcVerification,
    updatePost,
} from "../../../redux/actions";
import { CARD_ERRORS, TRANSACTION_TYPE } from "../../utils/constants";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import PriceText from "../PriceText";
import CountDownTimer from "../CountDownTimer";
import { setPost } from "../../../redux/actions/post";
import moment from "moment";
import PaymentOptions from "../PaymentOptions";

const RenderFees = ({ ppvFees }) => {
    if (Object.keys(ppvFees).length > 0) {
        if (ppvFees.fees && !!ppvFees.reg_gst && ppvFees.gst > 0) {
            return (
                <div className="ppv-chrg-text mb-1">
                    {currency(ppvFees.fees).format()} processing fee plus{" "}
                    {currency(ppvFees.gst).format()} GST will apply.
                </div>
            );
        } else {
            return (
                <div className="ppv-chrg-text mb-1">
                    {currency(ppvFees.fees).format()} processing fee will apply.
                </div>
            );
        }
    }

    return "";
};

const UnlockPurchaseButton = ({ posts, post }) => {
    const dispatch = useDispatch();

    const [ppvFees, setPpvFees] = useState("");
    const [confirming, setConfirming] = useState(false);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmStatus, setConfirmStatus] = useState(false);
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [isGettingPost, setIsGettingPost] = useState(false);

    const onSuccess = async () => {
        setIsGettingPost(true);
        await axios
            .get(`/api/posts/${post.id}`)
            .then((response) => {
                dispatch(
                    updatePost({
                        posts: posts,
                        activePost: response.data.post,
                    })
                );

                window.dispatchEvent(
                    new CustomEvent("post/unlocked", {
                        detail: {
                            post: response.data.post,
                        },
                    })
                );
                dispatch(setPost(response.data.post));

                setIsGettingPost(false);
            })
            .catch((error) => {
                setIsGettingPost(false);
                console.error(error);
                window.location.reload();
            });
    };

    const handleUnlock = () => {
        setConfirming(true);
        axios
            .get(`/api/posts/fees`, {
                params: {
                    ppv_price: post.price,
                    post_id: post.id,
                },
            })
            .then((response) => {
                setConfirming(false);
                setPpvFees(response.data);
            });
    };

    const handlePayment = async () => {
        dispatch(setSelectedPost(post));
        setShowConfirm(false);
        setProcessingPayment(true);
        axios
            .post("/api/posts/pay", {
                post_id: post.id,
            })
            .then((response) => {
                dispatch(
                    setAlert({
                        show: true,
                        type: "success",
                        body: `Payment successful`,
                    })
                );

                dispatch(
                    updatePost({
                        posts: posts,
                        activePost: response.data.post,
                    })
                );

                window.dispatchEvent(
                    new CustomEvent("post/unlocked", {
                        detail: {
                            post: response.data.post,
                        },
                    })
                );

                setProcessingPayment(false);
                // dispatch(setSelectedPost(response.data.post));
                dispatch(setPost(response.data.post));
            })
            .catch((error) => {
                setProcessingPayment(false);
                console.error({ error });
                if (error.response) {
                    if (error.response.status === 503) {
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.message ||
                                    'There is an error processing the payment, please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.',
                            })
                        );
                        return;
                    }
                    if (
                        error.response.data.message === CARD_ERRORS.NO_CARD &&
                        error.response.status === 402
                    ) {
                        setShowCcForm();
                        return;
                    }

                    if (
                        error.response.status === 409 ||
                        error.response.status === 402
                    ) {
                        if (
                            error.response.data.error ===
                            CARD_ERRORS.NEEDS_VALIDATION
                        ) {
                            dispatch(
                                updateCcVerification({
                                    showVerify: true,
                                })
                            );
                            return;
                        }
                        setShowCcForm();
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body: error.response.data.message,
                            })
                        );
                        return;
                    }

                    if (error.response.status === 403) {
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.message ||
                                    "Purchase is not allowed",
                            })
                        );
                        return;
                    }

                    if (
                        error.response &&
                        error.response.status > 400 &&
                        error.response.status < 500
                    ) {
                        setShowCcForm();
                    }
                }

                dispatch(
                    setAlert({
                        show: true,
                        type: "error",
                        body: `Payment failed. Please contact support <a href="https://priva.uvdesk.com/en/">here</a>`,
                    })
                );

                setProcessingPayment(false);
                dispatch(setSelectedPost({}));
            });
    };

    const handleCloseConfirm = () => {
        setShowConfirm(false);
    };

    const handleConfirmation = (e) => {
        e.preventDefault();
        setShowConfirm(true);
    };

    const setShowCcForm = () => {
        console.log({ post });
        dispatch(
            setCreditCardForm({
                show: true,
                prefilled: true,
                closeOnly: true,
                intent: "Post PPV payment",
                username: post.user.login,
                mode: "add",
            })
        );
    };

    const handleEndTime = () => {
        setIsDiscounted(false);
    };

    useEffect(() => {
        const discounted = !!(post.promo_price && post.expire_at);
        setIsDiscounted(discounted);

        if (post.expire_at) {
            const expiry = moment.utc(post.expire_at).local();
            if (moment().isSameOrAfter(expiry, "seconds")) {
                setIsDiscounted(false);
            } else {
                setIsDiscounted(true);
            }
        }

        return () => {};
    }, [post]);

    const handlePaymentOptions = () => {
        setShowPaymentOptions(!showPaymentOptions);
    };

    useEffect(() => {
        if (showPaymentOptions) {
            setShowConfirm(false);
        }
    }, [showPaymentOptions]);

    if (!ppvFees) {
        return (
            <div className="post__purchase">
                <button
                    className="btn btn-primary btn-rounded btn-post-ppv"
                    onClick={handleUnlock}
                    disabled={confirming}
                >
                    UNLOCK POST FOR{" "}
                    <PriceText
                        price={post.price}
                        discountedPrice={post.promo_price}
                        isDiscounted={isDiscounted}
                    />
                </button>

                {isDiscounted ? (
                    <div className="post_promo_counter">
                        <span className="limited-offer-label">
                            Limited offer expires in:
                        </span>
                        <br />
                        <CountDownTimer
                            dateTime={post.expire_at}
                            id={post.id}
                            onEndTime={handleEndTime}
                            isEmphasized={true}
                            isUTC
                        />
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }

    return (
        <div className="post__purchase">
            <Dialog
                open={showConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="confirm-postppv-title"
                aria-describedby="postppv-confirm-content"
            >
                <DialogTitle id="confirm-postppv-title">
                    {"Are you sure?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="postppv-confirm-content">
                        This action cannot be undone. You will be charged after
                        confirmation.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Cancel</Button>
                    <Button onClick={handlePaymentOptions} autoFocus>
                        Yes, continue payment
                    </Button>
                </DialogActions>
            </Dialog>

            <button
                className="btn btn-primary btn-rounded btn-post-ppv"
                onClick={handleConfirmation}
                disabled={processingPayment}
            >
                {processingPayment ? (
                    "Processing..."
                ) : (
                    <>
                        PAY{" "}
                        <PriceText
                            price={post.price}
                            discountedPrice={post.promo_price}
                            isDiscounted={isDiscounted}
                        />
                    </>
                )}
            </button>
            <RenderFees ppvFees={ppvFees} />
            {isDiscounted && !post.unlocked ? (
                <div className="post_promo_counter">
                    <span className="limited-offer-label">
                        Limited offer expires in:
                    </span>
                    <br />
                    <CountDownTimer
                        dateTime={post.expire_at}
                        id={post.id}
                        onEndTime={handleEndTime}
                        isEmphasized={true}
                        isUTC
                    />
                </div>
            ) : (
                ""
            )}

            {showPaymentOptions ? (
                <PaymentOptions
                    show={showPaymentOptions}
                    setShow={setShowPaymentOptions}
                    onClickPayNow={handlePayment}
                    amount={isDiscounted ? post.promo_price : post.price}
                    action={TRANSACTION_TYPE.POST_PPV}
                    pu={post.user}
                    onSuccess={onSuccess}
                    item={post}
                    isBusy={isGettingPost}
                />
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        posts: state.post.posts,
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
    UnlockPurchaseButton
);
